
export enum UserRolesEnum{
	admin = 'Administrator',
	anon = 'Anonymous',
	consumer = 'Consumer',
	developer = 'Developer',
	travelAdvisor = 'Travel Advisor',
	vendor = 'Vendor'
}


export enum TravelAdvisorPositionEnum {
	independentConsultant = 'Independent Consultant',
	agencyAdmin = 'Agency Admin',
	agencyOwner = 'Agency Owner',
	other = 'Other'
}
